import { QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { RouterProvider } from "@tanstack/react-router";
import { ErrorBoundary } from "react-error-boundary";
import { Toaster } from "./components/ui/toaster";
import MainProvider from "./context/user-information/user-information-provider";
import { router } from "./router";
import ErrorFallback from "./components/ErrorFallback";

import "slick-carousel/slick/slick-theme.css";
import "slick-carousel/slick/slick.css";
import "./style/global.css";
import { queryClient } from "./query-client";

export default function App() {
	return (
		<ErrorBoundary
			FallbackComponent={ErrorFallback}
			onReset={() => {
				queryClient.clear();
			}}
		>
			<QueryClientProvider client={queryClient}>
				<MainProvider>
					<ReactQueryDevtools initialIsOpen={false} />
					<RouterProvider context={{ queryClient }} router={router} />
					<Toaster />
				</MainProvider>
			</QueryClientProvider>
		</ErrorBoundary>
	);
}
